import TemplateView from "../../../TemplateView";
import {KEY_HANDLERS, isSpace, isEnter} from '../../../keyHandlers/index';

export default class BaseTasksChangeDialog extends TemplateView {

    constructor({$containerElement, cancelHandler = () => {}, submitHandler}) {
        super($containerElement);
        this.cancelHandler = cancelHandler;
        this.submitHandler = submitHandler;

        this.state = {
            numberOfTasks: -1,
            saving: false,
        }

        this.onStatePropertyChanged('numberOfTasks', () => {
            this._updateTitleText()
        })

        this.onStatePropertyChanged('saving', (saving) => {
            this.$el.toggleClass("savingState", saving)
        })
    }

    templateHtml() {
        return '<div>' +
               '  <div class="assignToDialogInnerContainer">' +
               '    ' +
               '    <div class="title"><%-titleText%></div>' +
               '    <div class="mainContainer">' +
               '      <div class="label"><%-labelText%></div>' +
               '      <div class="selectorContainer"></div>' +
               '    </div>' +
               '    <div class="buttonsContainer">' +
               '      <div class="withIcon submitBtn greyButton" tabindex="-1">' +
               '        <div class="buttonIcon">' +
               '          <span class="buttonTitle"><%-submitButtonText%></span>' +
               '        </div>' +
               '      </div>' +
               '      <div class="cancelBtn greyButton"><%=cancelButtonText%></div>' +
               '    </div>' +
               '  </div>' +
               '</div>';
    }

    afterRender() {
        this._setHandlers();
        this.$submitBtn = this.$el.find(".submitBtn")
    }

    show() {
        super.show()
        this._removeKeyDown = KEY_HANDLERS.onKeyDown((code) => {
            if (isEnter(code) || isSpace(code)) {
                this.onSubmit()
                return true
            }
        })

        this.$submitBtn.focus()
    }

    hide() {
        super.hide()
        if (this._removeKeyDown) this._removeKeyDown()
    }

    _setHandlers() {
        this.$el.find(".cancelBtn").unbind().click(() => {this._onCancel()});
        this.$el.find(".submitBtn").unbind().click(() => {this.onSubmit()});
    }

    _onCancel() {
        if (this.state.saving)
            return;

        this.cancelHandler();
    }

    onSubmit() {
        console.error('function _onSubmit not implemented');
    }

    templateModel() {
        return {
            titleText: this.titleText()
        }
    }

    _updateTitleText() {
        this.getTitleEl().text(this.titleText())
    }

    getTitleEl() {
        return this.find('.title')
    }

    titleText() {
        return ''
    }
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/components/BaseTasksChangeDialog.js